// tslint:disable:max-line-length

import React from 'react';

export const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="8,0.5 0.5,8 8,15.5 9.4,14.1 4.2,9 15.5,9 15.5,7 4.2,7 9.4,1.9" />
    </svg>
  );
};
